export default "__VITE_PUBLIC_ASSET__be08df5d__"